define("media/utils/object-promise-proxy", ["exports", "shared/utils/object-promise-proxy"], function (_exports, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "arrayPromiseProxy", {
    enumerable: true,
    get: function () {
      return _objectPromiseProxy.arrayPromiseProxy;
    }
  });
  Object.defineProperty(_exports, "default", {
    enumerable: true,
    get: function () {
      return _objectPromiseProxy.default;
    }
  });
  Object.defineProperty(_exports, "objectPromiseProxy", {
    enumerable: true,
    get: function () {
      return _objectPromiseProxy.objectPromiseProxy;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"shared/utils/object-promise-proxy",0,"shared/utils/object-promise-proxy"eaimeta@70e063a35619d71f
});